import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TModals } from 'shared/types/modals';

export const modalsSlice = createSlice({
  name: 'modals',
  initialState: { allFiltersModalOpened: false, datesPopupOpened: false } as TModals,
  reducers: {
    setAllFiltersModalOpen: (state, action: PayloadAction<boolean>) => {
      state.allFiltersModalOpened = action.payload;
    },
    setDatesPopupOpen: (state, action: PayloadAction<boolean>) => {
      state.datesPopupOpened = action.payload;
    },
  },
});

export const {
  reducer: modalsReducer,
  name: modalsReducerName,
  actions: { setAllFiltersModalOpen, setDatesPopupOpen },
} = modalsSlice;
